
<template>
<b-row class="d-flex flex-column align-items-center">
    <loading :show="loading" v-if="loading"/>
    <b-col v-else>
        <b-col>
            <b-table
                responsive
                bordered
                :items="studentInformationTableItems"
                :fields="fields"
                class="border "
            ></b-table>
        </b-col>
        <b-col>
            <b-table
                responsive
                bordered
                :items="examInformationTable"
                :fields="examFields"
                class="border"
            >

                <template #cell(attended)="{item}">
                    <b-form-checkbox
                        :id="'checkbox-' + item.exam_id "
                        :value="1"
                        @change="item.score=null"
                        :unchecked-value="0"
                        v-model="item.attended"
                    />
                </template>
                <template #cell(score)="{item}">
                    <validation-observer ref="observer">
                            <ValidationProvider
                                :name="`score-${item.exam_id}`"
                                :rules="item.attended?'required':''"
                                v-slot="{ valid, errors }"
                            >
                                <b-form-input
                                    :disabled="!item.attended"
                                    :placeholder="$t('grade_entry')"
                                    type="number"
                                    min="0"
                                    max="100"
                                    v-model="item.score"
                                ></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </ValidationProvider>
                    </validation-observer>
                </template>
                <template #cell(exam_name)="{item}">

                    <span>{{ item.exam_name }} - {{item.rank}}</span>
                 </template>


            </b-table>
            <b-col class="d-flex  justify-content-center align-item-center">
                <ProcessingButton  @click="updateScore" :processing="updateScoreLoading" :disabled="updateScoreLoading" />
            </b-col>
        </b-col>
    </b-col>

</b-row>
</template>

<script>
import ExamDefinationService from "@/services/ExamDefinationService";
import qs from "qs";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";

export default {
    components: {ProcessingButton},
    props:{
        student:{
          required:true
        },
        exams:{
            required: true
        },
        examScore:{
            required:true
        }
    },
    name: "EditGrade.vue",
    data(){
        return {
            studentInformationTableItems:[],
            fields: [
                {
                    key: 'student_number',
                    label:this.$t('student_number'),
                },
                {
                    key: 'name',
                    label: this.$t('name'),
                },
                {
                    key: 'surname',
                    label: this.$t('surname'),
                },

            ],
            examFields:[
                {
                    key: 'exam_name',
                    label:this.$t('exam'),
                    tdClass:'w-25'
                },
                {
                    key: 'date',
                    label: this.$t('date'),
                },
                {
                    key: 'attended',
                    label: 'attended',
                    tdClass:'w-25'
                },
                {
                    key: 'score',
                    label: this.$t('score'),
                },

            ],
            examInformationTable:[],
            selectedExam:{},
            loading:false,
            updateScoreLoading:false
        }
    },
    mounted() {
        let examIds =[]
        this.exams.forEach((examDefinition)=>{
            examDefinition.exams.forEach((exam)=>{
                examIds.push(exam.id)
            })
        })
        this.getExamScore(examIds)
    },
    methods:{
        getStudentExamScore(studentExamScores){
            let newObject =[]
            this.exams?.forEach((item)=>{
                item.exams.forEach((exam)=>{
                    const selectedExam =studentExamScores.find((score)=>score?.exam_id===exam?.id && score.student_program_id === this.student.student_program_id)
                    if (selectedExam){
                        newObject.push(
                            {
                                rank:exam.rank +1,
                                exam_id:exam.id,
                                exam_name:item?.name,
                                date:exam?.date,
                                score:selectedExam?.score,
                                attended:selectedExam?.attended?1:0,
                            }
                        )
                    }
                })
            })
            return newObject.sort((a,b)=>a.date.localeCompare(b.date))
        },
        async getExamScore(examIds){
            this.loading=true
            try {
                const config={
                    params:{
                        filter:{
                            student_program_id:this.student.student_program_id,
                            exam_id:examIds
                        },
                        limit:-1,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                const res= await ExamDefinationService.getExamScore(config)
                const data =res.data.data
                this.examInformationTable=this.getStudentExamScore(data)
                this.studentInformationTableItems.push({
                    student_number:this.student.student_number,
                    name:this.student.name,
                    surname: this.student.surname
                })
            }catch (err){
                this.showErrors(err,null)
            }finally {
                this.loading=false
            }
        },
       async updateScore(){

            const scores =this.examInformationTable.map((item)=>{
                return {
                    exam_id:item.exam_id,
                    score:item.score,
                    attended:item.attended?1:0
                }
            })
               const data ={
                    scores:scores
               }
            try {
                this.updateScoreLoading=true
                const res =await ExamDefinationService.examScoreUpdate(this.$route.params.sectionId,this.student.student_program_id,data)
                this.$toast.success('api.'+res.data.message)
                this.$emit('successScoreUpdate')
            }catch (e) {
                this.showErrors(e,this.$refs.observer)
            }finally {
                this.updateScoreLoading=false
            }
        }
    }
}
</script>

<style scoped>

</style>
